module.exports = "<svg viewBox=\"0 0 299.2 111.4\"><path d=\"M2.8 76.5h34.6v18.9H2.8V76.5z\" class=\"st0\"></path><path d=\"M34.8 40.7h63.6v18.9H34.8V40.7z\" class=\"st0\"></path><path d=\"M2.8 4.8h63.9v18.9H2.8V4.8z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-communication.svg
// module id = 283
// module chunks = 1